/******************************************************
 * Tooltip class
 *
 * a11y research:
 *
 * https://inclusive-components.design/tooltips-toggletips/
 * --	the section "TOOLTIP AS AUXILIARY DESCRIPTION"
 *
 * Programmatically inserting components using technique explained here:
 * https://css-tricks.com/creating-vue-js-component-instances-programmatically/
 */

import Tooltip from "@vg-faset/ui/src/components/tooltip/Tooltip";
import Vue from "vue";
import { EventBus } from "../index.js";
import { KEYS } from "../../utilities";

export class Tooltips {
	constructor() {
		this.tapEvent =
			"ontouchend" in document.documentElement ? "touchend" : "click";

		if (
			this.tapEvent === "click" &&
			!document.documentElement.classList.contains("no-touch")
		) {
			// iOS safari fires a hover event, grrrr
			document.documentElement.classList.add("no-touch");
		} else {
			document.documentElement.classList.add("touch");
		}
		this.bindGlobalListeners();

		this.setup();
	}

	setup(rootNode = document) {
		// grab all spans with [title]s that are not empty
		this.tooltips = Array.from(
			rootNode.querySelectorAll('span[title]:not([title=""])')
		);

		this.tooltips.forEach((tip) => {
			// if data attribute exists, update the forceup prop to true.
			// this forces the tooltip to always display above the link
			const attributeName = "data-force-tooltip-up";
			const forceUp =
				tip.hasAttribute(attributeName) &&
				tip.getAttribute(attributeName) === "true";

			var ComponentClass = Vue.extend(Tooltip);
			var instance = new ComponentClass({
				propsData: {
					text: tip.innerHTML,
					message: tip.getAttribute("title"),
					labelClasses: tip.className.split(" "),
					autoWidth: tip.getAttribute("data-width"),
					forceUp: forceUp
				}
			});

			instance.$mount();

			tip.parentElement.replaceChild(instance.$el, tip);
		});
	}

	// help keep only one tooltip active at a time
	clearActive() {
		EventBus.$emit("tooltip:clear", "mixin");
	}

	bindGlobalListeners() {
		// Remove tooltip on ESC (forcing blur)
		document.addEventListener("keydown", (e) => {
			if ((e.keyCode || e.which) === KEYS.ESC) {
				this.clearActive();
				return;
			}
		});

		// if you touch/click anywhere that is not a tooltip it should clear
		// any open tooltip
		document.addEventListener(this.tapEvent, (e) => {
			let trigger = e.target.hasAttribute("data-tooltip-trigger");

			// if we tapped anywhere that is not a tooltip
			if (!trigger) {
				this.clearActive();
				return;
			}
		});
	}
}

const tips = new Tooltips();

export default {
	mounted() {
		this.$nextTick(function () {
			tips.setup();
		});
	},

	updated() {
		this.$nextTick(function () {
			tips.setup();
		});
	},

	watch: {
		labelTip() {
			this.$nextTick(function () {
				tips.setup();
			});
		}
	}
};
